import React, { useState, useEffect } from 'react';
import Logo from '../../Markup/assets/img/WpdLogoWithText.svg';
import CartEmptyIllustration from '../../Markup/assets/img/Cart-empty.svg';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import EA from '../../Markup/assets/img/EA-Logo.png';
import BD from '../../Markup/assets/img/Betterdocs-icon.png';
import NX from '../../Markup/assets/img/NotificationX.svg';
import EP from '../../Markup/assets/img/embedpress-icon.svg';
import BL from '../../Markup/assets/img/betterlinks-icon.png';
import SP from '../../Markup/assets/img/wp-scheduled-posts-logo.png';
import Agency from '../../Markup/assets/img/wpdev-all-access-bundle.png';
import EB from '../../Markup/assets/img/essential-blocks-icon.png';
import BP from '../../Markup/assets/img/better-payment.png';
import XC from '../../Markup/assets/img/xspeed-cache.png';
import TR from '../../Markup/assets/img/thinkrank.png';

import Footer from '../Common/Footer';

import { getCoupons } from '../../utils/UpsellProducts';
import { getProductPrice } from '../../utils/productPrices';
import { AGENCY_BUNDLE_ID } from '../../utils/AgencyBundleProducts';

const staticProducts = [
	{
		id: 1,
		name: 'Essential Addons',
		icon: EA,
		priceOptions: [
			{
				value: '1 Website',
				label: '1 Website',
				// price: '$49.97',
				price: '$4.99/mo',
				dealPrice: '$3.499/mo',
				description: [
					'Activation on 1 site',
					'1 Year Support',
					'1 Year Update',
					'Billed Annually',
				],
				default: true,
				priceId: 1,
				downloadId: 4372,
				coupon: getCoupons(4372, 1),
			},
			{
				value: 'Unlimited',
				label: 'Unlimited',
				// price: '$99.97',
				price: '$9.99/month',
				dealPrice: '$6.50/mo',
				description: [
					'Unlimited Activation',
					'1 Year Support',
					'1 Year Update',
					'Billed Annually',
				],
				priceId: 3,
				downloadId: 4372,
				coupon: getCoupons(4372, 3),
			},
			{
				value: 'Lifetime Unlimited',
				label: 'Lifetime Unlimited',
				price: '$299.99',
				dealPrice: '$179.99',
				description: [
					'Unlimited Activation',
					'Lifetime Support',
					'Lifetime Updates',
					'No Renewal Required',
				],
				priceId: 4,
				downloadId: 4372,
				coupon: getCoupons(4372, 4),
			},
		],
	},
	{
		id: 2,
		name: 'BetterDocs',
		icon: BD,
		priceOptions: [
			{
				value: 'Starter',
				label: 'Starter',
				price: '$69',
				dealPrice: '$48',
				description: [
					'Activation on 1 Site',
					'1 Year Support',
					'1 Year Update',
				],
				default: true,
				priceId: 1,
				downloadId: 342422,
				coupon: getCoupons(342422, 1),
			},
			{
				value: 'Innovator',
				label: 'Innovator',
				price: '$149',
				dealPrice: '$97',
				description: [
					'Unlimited Activation',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 2,
				downloadId: 342422,
				coupon: getCoupons(342422, 2),
			},
			{
				value: 'Visionary',
				label: 'Visionary',
				price: '$299',
				dealPrice: '$179',
				description: [
					'Unlimited Activation',
					'Lifetime Support',
					'Lifetime Updates',
					'No Renewal Required',
				],
				priceId: 3,
				downloadId: 342422,
				coupon: getCoupons(342422, 3),
			},
		],
	},
	{
		id: 3,
		name: 'NotificationX',
		icon: NX,
		priceOptions: [
			{
				value: 'Individual',
				label: 'Individual',
				price: '$49',
				dealPrice: '$34',
				description: [
					'Activation on 1 site',
					'1 Year Support',
					'1 Year Update',
				],
				default: true,
				priceId: 1,
				downloadId: 99658,
				coupon: getCoupons(99658, 1),
			},
			{
				value: 'Business',
				label: 'Business',
				price: '$199',
				dealPrice: '$129',
				description: [
					'Unlimited Activation',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 3,
				downloadId: 99658,
				coupon: getCoupons(99658, 3),
			},
			{
				value: 'Lifetime Unlimited',
				label: 'Lifetime Unlimited',
				price: '$399',
				dealPrice: '$239',
				description: [
					'Unlimited Activation',
					'Lifetime Support',
					'Lifetime Updates',
					'No Renewal Required',
				],
				priceId: 4,
				downloadId: 99658,
				coupon: getCoupons(99658, 4),
			},
		],
	},
	{
		id: 4,
		name: 'EmbedPress',
		icon: EP,
		priceOptions: [
			{
				value: 'Individual',
				label: 'Individual',
				price: '$69',
				dealPrice: '$48',
				description: [
					'Activation on 1 site',
					'1 Year Support',
					'1 Year Update',
					'Standard support',
				],
				default: true,
				priceId: 1,
				downloadId: 414494,
				coupon: getCoupons(414494, 1),
			},
			{
				value: 'Business',
				label: 'Business',
				price: '$199',
				dealPrice: '$129',
				description: [
					'Unlimited Activation',
					'1 Year Support',
					'1 Year Update',
					'Priority support',
				],
				priceId: 2,
				downloadId: 414494,
				coupon: getCoupons(414494, 2),
			},
			{
				value: 'Lifetime Unlimited',
				label: 'Lifetime Unlimited',
				price: '$399',
				dealPrice: '$239',
				description: [
					'Unlimited Activation',
					'Lifetime Priority Support',
					'Lifetime Updates',
					'No Renewal Required',
				],
				priceId: 3,
				downloadId: 414494,
				coupon: getCoupons(414494, 3),
			},
		],
	},
	{
		id: 5,
		name: 'BetterLinks',
		icon: BL,
		priceOptions: [
			{
				value: 'Individual',
				label: 'Individual',
				price: '$99',
				dealPrice: '$69',
				description: [
					'Activation on 1 site',
					'1 Year Support',
					'1 Year Update',
				],
				default: true,
				priceId: 1,
				downloadId: 764539,
				coupon: getCoupons(764539, 1),
			},
			{
				value: 'Business',
				label: 'Business',
				price: '$249',
				dealPrice: '$162',
				description: [
					'Unlimited Activation',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 2,
				downloadId: 764539,
				coupon: getCoupons(764539, 2),
			},
			{
				value: 'Agency (Lifetime)',
				label: 'Agency (Lifetime)',
				price: '$399',
				dealPrice: '$239',
				description: [
					'Unlimited Activation',
					'Lifetime Support',
					'Lifetime Updates',
					'No Renewal Required',
				],
				priceId: 3,
				downloadId: 764539,
				coupon: getCoupons(764539, 3),
			},
		],
	},
	{
		id: 6,
		name: 'SchedulePress',
		icon: SP,
		priceOptions: [
			{
				value: 'Individual',
				label: 'Individual',
				price: '$49',
				dealPrice: '$34',
				description: [
					'Activation on 1 site',
					'1 Year Support',
					'1 Year Update',
				],
				default: true,
				priceId: 1,
				downloadId: 78593,
				coupon: getCoupons(78593, 1),
			},
			{
				value: 'Business',
				label: 'Business',
				price: '$149',
				dealPrice: '$97',
				description: [
					'Unlimited Activation',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 3,
				downloadId: 78593,
				coupon: getCoupons(78593, 3),
			},
			{
				value: 'Lifetime Unlimited',
				label: 'Lifetime Unlimited',
				price: '$399',
				dealPrice: '$239',
				description: [
					'Unlimited Activation',
					'Lifetime Support',
					'Lifetime Updates',
					'No Renewal Required',
				],
				priceId: 4,
				downloadId: 78593,
				coupon: getCoupons(78593, 4),
			},
		],
	},
	{
		id: 7,
		name: 'Essential Blocks',
		icon: EB,
		priceOptions: [
			{
				value: 'Starter',
				label: 'Starter',
				price: '$49',
				dealPrice: '$34',
				description: [
					'Activation on 1 site',
					'1 Year Support',
					'1 Year Update',
				],
				default: true,
				priceId: 1,
				downloadId: 1677666,
				coupon: getCoupons(1677666, 1),
			},
			{
				value: 'Innovator',
				label: 'Innovator',
				price: '$149',
				dealPrice: '$97',
				description: [
					'Activation on 5 Sites',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 2,
				downloadId: 1677666,
				coupon: getCoupons(1677666, 2),
			},
			{
				value: 'Visionary',
				label: 'Visionary',
				price: '$349',
				dealPrice: '$209',
				description: [
					'Activation on 100 Sites',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 3,
				downloadId: 1677666,
				coupon: getCoupons(1677666, 3),
			},
			{
				value: 'VisionaryLTD',
				label: 'Visionary Lifetime',
				price: '$399',
				dealPrice: '$299',
				description: [
					'Activation on 100 Sites',
					'Lifetime Support',
					'Lifetime Updates',
					'No Renewal Required',
				],
				priceId: 6,
				downloadId: 1677666,
				coupon: getCoupons(1677666, 6),
			},
		],
	},
	{
		id: 8,
		name: 'Better Payment',
		icon: BP,
		priceOptions: [
			{
				value: 'Single Sites',
				label: 'Single Sites',
				price: '$59',
				dealPrice: '$41',
				description: [
					'Activation on 1 site',
					'1 Year Support',
					'1 Year Update',
				],
				default: true,
				priceId: 1,
				downloadId: 1738966,
				coupon: getCoupons(1738966, 1),
			},
			{
				value: 'Unlimited Sites',
				label: 'Unlimited Sites',
				price: '$199',
				dealPrice: '$129',
				description: [
					'Unlimited Activation',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 2,
				downloadId: 1738966,
				coupon: getCoupons(1738966, 2),
			},
			{
				value: 'Lifetime',
				label: 'Lifetime',
				price: '$499',
				dealPrice: '$299',
				description: [
					'Unlimited Activation',
					'Lifetime Support',
					'Lifetime Updates',
					'No Renewal Required',
				],
				priceId: 3,
				downloadId: 1738966,
				coupon: getCoupons(1738966, 3),
			},
		],
	},
	{
		id: 9,
		name: 'xSpeed Cache',
		icon: XC,
		priceOptions: [
			{
				value: 'Personal',
				label: 'Personal',
				price: '$58',
				dealPrice: '$29',
				description: [
					'Activation on 1 site',
					'1 Year Support',
					'1 Year Update',
				],
				default: true,
				priceId: 1,
				downloadId: 1971379,
				coupon: getCoupons(1971379, 1),
			},
			{
				value: 'Business',
				label: 'Business',
				price: '$98',
				dealPrice: '$49',
				description: [
					'Activation on 5 site',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 2,
				downloadId: 1971379,
				coupon: getCoupons(1971379, 2),
			},
			{
				value: 'Agency',
				label: 'Agency',
				price: '$198',
				dealPrice: '$99',
				description: [
					'Activation on 25 site',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 3,
				downloadId: 1971379,
				coupon: getCoupons(1971379, 3),
			},
			{
				value: 'Enterprise',
				label: 'Enterprise',
				price: '$398',
				dealPrice: '$199',
				description: [
					'Unlimited Sites',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 4,
				downloadId: 1971379,
				coupon: getCoupons(1971379, 4),
			},
		],
	},
	{
		id: 10,
		name: 'ThinkRank',
		icon: TR,
		priceOptions: [
			{
				value: 'Starter',
				label: 'Starter',
				price: '$99',
				dealPrice: '$49.50',
				description: [
					'Activation on 1 site',
					'1 Year Support',
					'1 Year Update',
				],
				default: true,
				priceId: 1,
				downloadId: 1971322,
				coupon: getCoupons(1971322, 1),
			},
			{
				value: 'Innovator',
				label: 'Innovator',
				price: '$159',
				dealPrice: '$79.50',
				description: [
					'Activation on 5 site',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 2,
				downloadId: 1971322,
				coupon: getCoupons(1971322, 2),
			},
			{
				value: 'Visionary',
				label: 'Visionary',
				price: '$249',
				dealPrice: '$124.50',
				description: [
					'Unlimited Sites',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 3,
				downloadId: 1971322,
				coupon: getCoupons(1971322, 3),
			},
		],
	},
	{
		id: 11,
		name: 'Agency Bundle',
		icon: Agency,
		priceOptions: [
			{
				value: 'Agency Bundle Unlimited / Monthly',
				label: 'Agency Bundle Unlimited / Monthly',
				price: '$29',
				dealPrice: '$29',
				description: [
					'Unlimited Sites',
					'1 Month Support',
					'1 Month Update',
				],
				default: true,
				priceId: 5,
				downloadId: AGENCY_BUNDLE_ID,
				coupon: getCoupons(AGENCY_BUNDLE_ID, 5),
			},
			{
				value: 'Agency Bundle Unlimited / Yearly',
				label: 'Agency Bundle Unlimited / Yearly',
				price: '$399',
				dealPrice: '$269',
				description: [
					'Unlimited Sites',
					'1 Year Support',
					'1 Year Update',
				],
				priceId: 1,
				downloadId: AGENCY_BUNDLE_ID,
				coupon: getCoupons(AGENCY_BUNDLE_ID, 1),
			},
			{
				value: 'Agency Bundle Lifetime Unlimited',
				label: 'Agency Bundle Lifetime Unlimited',
				price: '$999',
				dealPrice: '$649',
				description: [
					'Unlimited Activation',
					'Lifetime Support',
					'Lifetime Updates',
					'No Renewal Required',
				],
				priceId: 2,
				downloadId: AGENCY_BUNDLE_ID,
				coupon: getCoupons(AGENCY_BUNDLE_ID, 2),
			},
		],
	},
];
export const EmptyCart = ({ addToCart, loading, cartData }) => {
	const [allSelected, setAllSelected] = useState([]);

	useEffect(() => {
		if (localStorage.getItem('old_cart')) {
			localStorage.removeItem('old_cart');
		}
	}, []);

	const setProductSelectedPrice = (selectedOption, product) => {
		const all = allSelected.filter(val => val.productId !== product.id);
		setAllSelected([...all, { productId: product.id, ...selectedOption }]);
	};

	const getSelectedOption = product => {
		if (allSelected && allSelected.length) {
			const hasSelected = allSelected
				.filter(option => option.productId === product.id)
				.shift();

			if (hasSelected) {
				const getSelected = product.priceOptions
					.filter(
						option =>
							option.downloadId === hasSelected.downloadId &&
							option.priceId === hasSelected.priceId
					)
					.shift();
				if (getSelected) {
					return getSelected;
				}
			}
		}
		return product.priceOptions.filter(option => !!option.default);
	};
	const Description = ({ product }) => {
		let option = undefined;
		if (allSelected && allSelected.length) {
			const hasSelected = allSelected.filter(
				val => val.productId === product.id
			);
			if (hasSelected.length) {
				option = hasSelected.shift();
			}
		}
		if (!option) {
			option = product.priceOptions.filter(val => !!val.default).shift();
		}

		let basePrice = getProductPrice(option.downloadId, option.priceId);
		let dealPrice =
			getProductPrice(option.downloadId, option.priceId, 'dealPrice') ||
			null;
		if (+option.downloadId === 4372 && +option.priceId !== 4) {
			basePrice =
				getProductPrice(
					option.downloadId,
					option.priceId,
					'basePrice',
					true
				) + '/mo';
			dealPrice =
				getProductPrice(
					option.downloadId,
					option.priceId,
					'dealPrice',
					true
				) + '/mo';
		}

		return (
			<>
				<p className="WpdProductPrice">
					<b>Price: </b>
					{dealPrice && (
						<span className="WpdProductPrice-compareAt">
							${basePrice}
						</span>
					)}
					${dealPrice ? dealPrice : basePrice}
				</p>
				{typeof option.description === 'object' ? (
					<ul className="WpdProductPriceInfoDescription">
						{option.description.map(data => {
							return <li key={Math.random()}>{data}</li>;
						})}
					</ul>
				) : (
					<p className="WpdProductPriceInfoDescription">
						<b>Details: </b>
						{option.description}
					</p>
				)}
			</>
		);
	};
	const handleAddToCart = (e, product) => {
		e.preventDefault();
		let selectedPrice = undefined;
		if (allSelected.length) {
			selectedPrice = allSelected
				.filter(val => val.productId === product.id)
				.shift();
		}
		if (!selectedPrice) {
			selectedPrice = product.priceOptions
				.filter(val => !!val.default)
				.shift();
		}
		if (selectedPrice) {
			addToCart({
				download_id: selectedPrice.downloadId,
				price_id: selectedPrice.priceId,
				coupon: selectedPrice.coupon ?? '',
			});
		}
	};
	return (
		<div className="WpdPageBody WpdEmptyCartBody WpdDarkView">
			<header className="WpdEmptyCartHeader">
				<div className="WpdEmptyCartHeaderWrapper">
					<Link
						to={'/auth/sign-in'}
						className="WpdCompanyLogo mr-2"
					>
						<img
							src={Logo}
							alt="WPDeveloper"
						/>
					</Link>
					<ul className="nav d-flex justify-content-end ml-auto">
						<li className="nav-item">
							<a
								href={`${process.env.REACT_APP_SITE_URL}/about`}
								className="nav-link text-white py-1 px-2"
							>
								About
							</a>
						</li>
						<li className="nav-item ml-2">
							<a
								href={`${process.env.REACT_APP_SITE_URL}/blog`}
								className="nav-link text-white py-1 px-2"
							>
								Blog
							</a>
						</li>
						<li className="nav-item ml-2">
							<a
								href={`${process.env.REACT_APP_SITE_URL}/docs`}
								className="nav-link text-white py-1 px-2"
							>
								Docs
							</a>
						</li>
					</ul>
				</div>
			</header>
			<div className="WpdEmptyCartWrapper">
				<div className="WpdEmptyCartMessageWrapper">
					<div className="WpdEmptyCartMessage">
						<h2 className="WpdEmptyCartMessageTitle">
							Your Cart is Empty
						</h2>
						<p className="WpdEmptyCartMessageText">
							Looks like you haven't added any Products to your
							Cart yet, you can add products from below.
						</p>
					</div>
					<img
						src={CartEmptyIllustration}
						alt=""
						className="w-100 img-fluid"
					/>
				</div>
				<div className="WpdProductPromoSection">
					{staticProducts.map((item, index) => {
						return (
							<div
								className={`WpdProductPromo ${
									item.id === 11
										? 'WpdProductPromoAgency'
										: ''
								}`}
								key={Math.random()}
							>
								<div className="WpdProductPromoThumbnailWrapper">
									<div className="WpdProductPromoThumbnail">
										<img
											src={item.icon}
											alt="NotificationX"
										/>
									</div>
								</div>
								<div className="WpdProductPromoDetails">
									<h2 className="WpdProductPromoTitle">
										{item.name}
									</h2>
									<div className="WpdProductPriceInfoWrapper">
										<Select
											options={item.priceOptions}
											value={getSelectedOption(item)}
											onChange={selected =>
												setProductSelectedPrice(
													selected,
													item
												)
											}
											className="WpdCartSelect"
											classNamePrefix="WpdCartSelect"
											placeholder={'Select from below'}
										/>
										<Description product={item} />
									</div>
									<button
										className="WpdButton WpdInfoButton WpdFilled"
										onClick={e => handleAddToCart(e, item)}
									>
										<span className="WpdButtonInner">
											<span className="WpdText">
												Add to Cart
											</span>
										</span>
									</button>
								</div>
							</div>
						);
					})}
				</div>
			</div>
			<Footer style={{ textAlign: 'center ' }} />
		</div>
	);
};

export default EmptyCart;
